//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LocationAddressDisplayItem } from './LocationAddressDisplayItem';
import { LocationAddressType } from './Enums';

export class BasicAddressDisplayItem extends LocationAddressDisplayItem {
    override readonly AddressType: LocationAddressType = LocationAddressType.BasicAddress;
    Address: string | null = null;

    constructor(initializer?: Partial<Omit<BasicAddressDisplayItem, "AddressType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "BasicAddressDisplayItem";
}
